<template>
  <b-form-checkbox
    v-model="checked"
    :name="name"
    :switch="isSwitch"
    :size="size"
    @input="onInput()"
    >{{ message }}
  </b-form-checkbox>
</template>

<script>
/**
 * @description Contrôle pour un checkbox
 * @author Gabriel Bertrand
 * @vue-prop {string} name - Nom qui sera affiché dans l'étiquette
 * @vue-prop {Boolean} isChecked - Si le champ est coché par défaut ou non
 * @vue-prop {Boolean} isSwitch - Permet de changer la checkbox en toggle
 * @vue-prop {String} size - Permet de changer la grosseur de la composante
 * @vue-prop {String} message - Message à côté de la checkbox
 * @vue-data {Boolean} checked - La valeur du checkbox
 * @vue-event {Boolean} update-status - Est émis quand le checkbox change d'état
 */
export default {
  props: {
    name: {
      type: String,
      required: false,
      default: "checkbox"
    },
    isChecked: Boolean,
    isSwitch: Boolean,
    size: {
      type: String,
      required: false,
      default: ""
    },
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      checked: this.isChecked
    };
  },
  methods: {
    /**
     * @description Méthode qui passe la valeur du checkbox au input
     */
    onInput() {
      this.$emit("update-status", this.checked);
    }
  }
};
</script>
<style lang="scss">
.custom-checkbox .custom-control-label::before {
  border-radius: 5px !important;
  border: $primary solid 1px !important;
}
.custom-switch .custom-control-label::before {
  border: $primary solid 1px !important;
  height: 0.5rem;
  margin-top: 0.3rem;
  margin-left: 0.1rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 1.5px) !important ;
  left: calc(-2.25rem + 1.5px) !important;
  width: calc(1rem - 2px) !important;
  height: calc(1rem - 2px) !important;
  background-color: $primary !important;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $primary !important;
}
.custom-switch .custom-control-label::before {
  width: 1.5rem !important;
}
</style>
